var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.5H5.17501C6.52501 2.5 7.5875 3.6625 7.475 5L6.4375 17.45C6.2625 19.4875 7.87499 21.2375 9.92499 21.2375H23.2375C25.0375 21.2375 26.6125 19.7625 26.75 17.975L27.425 8.60001C27.575 6.52501 26 4.83749 23.9125 4.83749H7.77501",
    stroke: "#38F2E4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 27.5C21.6754 27.5 22.375 26.8004 22.375 25.9375C22.375 25.0746 21.6754 24.375 20.8125 24.375C19.9496 24.375 19.25 25.0746 19.25 25.9375C19.25 26.8004 19.9496 27.5 20.8125 27.5Z",
    stroke: "#38F2E4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 27.5C11.6754 27.5 12.375 26.8004 12.375 25.9375C12.375 25.0746 11.6754 24.375 10.8125 24.375C9.94956 24.375 9.25 25.0746 9.25 25.9375C9.25 26.8004 9.94956 27.5 10.8125 27.5Z",
    stroke: "#38F2E4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 10H26.75",
    stroke: "#38F2E4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBlue);
export default __webpack_public_path__ + "static/media/CartBlue.4e75e7dce68e33936195514f36829242.svg";
export { ForwardRef as ReactComponent };